import { useEffect } from 'react'
import { useKeycloak } from '@/hooks/use-keycloak-wrapper'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { LoginPageWithVerification } from './LoginWithVerification'

export function LoginPage() {
  const { keycloak, initialized } = useKeycloak()
  const navigate = useNavigate()
  const { t } = useTranslation()

  // Check if SSO is disabled
  const disableSSO = import.meta.env.VITE_DISABLE_SSO === 'true'

  useEffect(() => {
    if (initialized && !disableSSO) {
      if (keycloak.authenticated) {
        navigate('/app/dashboard', { replace: true })
      }
      // Don't auto-redirect to Keycloak — let user see the login page first
    }
  }, [initialized, keycloak, navigate, disableSSO])

  // Show the email/password login form (works for both SSO and non-SSO modes)
  return <LoginPageWithVerification />
}
